const initialStateConsumption = {
    energy: ['0-2000kw', '2000-3000kw', '3000kw'],
    gas: ['0-100', '100-300', '300']
}

export function consumptionReducer (state = initialStateConsumption, action) {
    switch (action.type) {
        default: {
            return state;
        }
    }
}